import React from "react";
import { Navigate } from "react-router-dom";
import { getSecureLocalItem } from "utils/secureSessionStorage";

const ProtectedRoute = ({ children }) => {
  const token = getSecureLocalItem("token");
  
  if (!token) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return children;
};

export default ProtectedRoute;
